export default "__VITE_ASSET__DMOzqyYy__"